export default __webpack_public_path__ + "static/media/consumer_report-hover.f3f443c5.svg";